import bishopBlack from '@/ui/icons/chess/bishop-black.svg';
import bishopWhite from '@/ui/icons/chess/bishop-white.svg';
import kingBlack from '@/ui/icons/chess/king-black.svg';
import kingWhite from '@/ui/icons/chess/king-white.svg';
import knightBlack from '@/ui/icons/chess/knight-black.svg';
import knightWhite from '@/ui/icons/chess/knight-white.svg';
import pawnBlack from '@/ui/icons/chess/pawn-black.svg';
import pawnWhite from '@/ui/icons/chess/pawn-white.svg';
import queenBlack from '@/ui/icons/chess/queen-black.svg';
import queenWhite from '@/ui/icons/chess/queen-white.svg';
import rookBlack from '@/ui/icons/chess/rook-black.svg';
import rookWhite from '@/ui/icons/chess/rook-white.svg';

/** FEN letter to its art, shared by the board and the duel overlay export. */
export const CHESS_PIECE_SVGS: Record<string, string> = {
  K: kingWhite,
  Q: queenWhite,
  R: rookWhite,
  B: bishopWhite,
  N: knightWhite,
  P: pawnWhite,
  k: kingBlack,
  q: queenBlack,
  r: rookBlack,
  b: bishopBlack,
  n: knightBlack,
  p: pawnBlack,
};

export enum GamChessboardMode {
  PLAY = 'play',
  VIEW = 'view',
  REPLAY = 'replay',
}

export enum GamChessboardOrientation {
  WHITE = 'white',
  BLACK = 'black',
  AUTO = 'auto',
}
